const AI_VIRTUAL_STAGING_IDS = [338, 337, 336, 342];

const virtualAIStagingConfig = {
  steps: [
    { id: 'selectPicture', component: 'SelectPictureStep', parameters: {} },
    {
      id: 'selectStagingOptions',
      component: 'SelectStagingOptionsStep',
      parameters: {},
    },
  ],
};

export function loadServiceConfig(service_offer_id: number) {
  switch (true) {
    case AI_VIRTUAL_STAGING_IDS.includes(service_offer_id):
      return virtualAIStagingConfig;
    default:
      return null;
  }
}

export const VARIATION_LIMIT = 17;
